/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./types/api";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const updateServiceCostSavingRule = /* GraphQL */ `mutation UpdateServiceCostSavingRule($input: [ServiceCostSavingRuleInput!]!) {
  updateServiceCostSavingRule(input: $input)
}
` as GeneratedMutation<
  APITypes.UpdateServiceCostSavingRuleMutationVariables,
  APITypes.UpdateServiceCostSavingRuleMutation
>;
export const updateAwsConnectionServiceCostSavingRule = /* GraphQL */ `mutation UpdateAwsConnectionServiceCostSavingRule(
  $input: [AwsConnectionServiceCostSavingRuleInput!]!
) {
  updateAwsConnectionServiceCostSavingRule(input: $input)
}
` as GeneratedMutation<
  APITypes.UpdateAwsConnectionServiceCostSavingRuleMutationVariables,
  APITypes.UpdateAwsConnectionServiceCostSavingRuleMutation
>;
export const forceServiceStatusChange = /* GraphQL */ `mutation ForceServiceStatusChange($input: ForceServiceStatusChangeInput!) {
  forceServiceStatusChange(input: $input) {
    success
    details
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ForceServiceStatusChangeMutationVariables,
  APITypes.ForceServiceStatusChangeMutation
>;
export const forceAwsConnectionServiceStatusChange = /* GraphQL */ `mutation ForceAwsConnectionServiceStatusChange(
  $input: ForceAwsConnectionServiceStatusChangeInput!
) {
  forceAwsConnectionServiceStatusChange(input: $input) {
    success
    details
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ForceAwsConnectionServiceStatusChangeMutationVariables,
  APITypes.ForceAwsConnectionServiceStatusChangeMutation
>;
export const serviceStatusChange = /* GraphQL */ `mutation ServiceStatusChange($input: ServiceStatusChangedInput!) {
  serviceStatusChange(input: $input) {
    cluster
    service
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ServiceStatusChangeMutationVariables,
  APITypes.ServiceStatusChangeMutation
>;
export const registerAwsConnection = /* GraphQL */ `mutation RegisterAwsConnection($input: RegisterAwsConnectionInput!) {
  registerAwsConnection(input: $input) {
    awsConnectionId
    accountId
    roleArn
    installationId
    stackId
    status
    commercialStatus
    createdAt
    updatedAt
    lastVerifiedAt
    lastInventoryRefreshAt
    lastInventoryRefreshAttemptAt
    lastInventoryRefreshFailedAt
    lastInventoryRefreshError
    inventoryRefreshFailureCount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RegisterAwsConnectionMutationVariables,
  APITypes.RegisterAwsConnectionMutation
>;
export const verifyAwsConnection = /* GraphQL */ `mutation VerifyAwsConnection($input: VerifyAwsConnectionInput!) {
  verifyAwsConnection(input: $input) {
    awsConnectionId
    accountId
    roleArn
    installationId
    stackId
    status
    commercialStatus
    createdAt
    updatedAt
    lastVerifiedAt
    lastInventoryRefreshAt
    lastInventoryRefreshAttemptAt
    lastInventoryRefreshFailedAt
    lastInventoryRefreshError
    inventoryRefreshFailureCount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.VerifyAwsConnectionMutationVariables,
  APITypes.VerifyAwsConnectionMutation
>;
export const refreshAwsConnectionInventory = /* GraphQL */ `mutation RefreshAwsConnectionInventory(
  $input: RefreshAwsConnectionInventoryInput!
) {
  refreshAwsConnectionInventory(input: $input) {
    cluster
    services {
      name
      launchType
      operatingSystem
      architecture
      minTaskCount
      maxTaskCount
      desiredTaskCount
      runningCount
      pendingCount
      vCpuPerTask
      memoryPerTask
      costPerTaskPerMinute
      actualStatus
      costSavingDetails {
        enableCostSaving
        expectedTaskCount
        pricePerMinutePerTask
        status
        rules {
          shutdownAt
          startupAt
          __typename
        }
        savings {
          estimatedWeekly
          estimatedMonthly
          current
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RefreshAwsConnectionInventoryMutationVariables,
  APITypes.RefreshAwsConnectionInventoryMutation
>;
